import { useWorkspaceStore } from "./workspace";
import { throttle } from 'lodash';
import { createProjectScopedStore } from "./projectScoped";
export interface InstructionsState {
  instructions: string;
  lastUpdated: number;
}

const initialState: InstructionsState = {
  instructions: '',
  lastUpdated: 0
};

export type InstructionsActions = {
  setInstructions: (instructions: string | ((prev: string) => string), force?: boolean) => void;
  reset: () => void;
};


const throttledUpdateWorkspaceInstructions = throttle((instructions: string) => {
  if (useWorkspaceStore.getState().instructions !== instructions) {
    useWorkspaceStore.setState({ instructions });
  }
}, 1000, { leading: true, trailing: true });

export const useInstructionsStore = createProjectScopedStore<InstructionsState & InstructionsActions>('instructions', (set, get) => ({
  ...initialState,

  setInstructions: (updater, force) => {
    const prevInstructions = get().instructions;
    set((state) => ({
      instructions: typeof updater === 'function' ? updater(state.instructions) : updater
    }));
    const instructions = get().instructions;
    if (prevInstructions !== instructions) {
      set({ lastUpdated: Date.now() });
    }
    if (force) {
      useWorkspaceStore.setState({ instructions: get().instructions });
    } else {
      throttledUpdateWorkspaceInstructions(get().instructions);
    }
  },

  reset: () => {
    set(initialState);
  },
}));
